export default __webpack_public_path__ + "static/media/minibanner.0dea3336.jpg";